export const XBIT_RELAY_TRANSACTION_RESCAN_PERMISSION_RESOURCE = 'xbit-relay:transaction-rescan';
